import { ExperimentFallbackConfigs } from "./experimentConfig";

export enum TrafficType {
  User = "user", // for logged in experiments
  Anonymous = "anonymous", // for logged out (using segment ID)
}

// https://help.split.io/hc/en-us/articles/360026943552-Attach-configurations-to-your-treatments
export interface ExperimentConfig {
  [key: string]:
    | string
    | number
    | boolean
    | Array<string | number | boolean>
    | this;
}

export type ExperimentConfigVal = ExperimentConfig[string];

export type Experiment = keyof typeof ExperimentFallbackConfigs;

export type ExperimentFallbackConfig<T extends Experiment> =
  (typeof ExperimentFallbackConfigs)[T];

export function isTrafficType(val?: string): val is TrafficType {
  return !!val && Object.values(TrafficType).includes(val as TrafficType);
}

// ----- Verify ExperimentFallbackTreatments have the expected types -----
type ExperimentToConfig = Record<Experiment, ExperimentConfig>;
// We can't add this type directly to ExperimentFallbackTreatments because we'd lose type inference!!
export const _typecheckExperimentFallbackTreatments: ExperimentToConfig =
  ExperimentFallbackConfigs;
